/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Navigation_No_Recent_ItemsInputs */



/**
* | output |
* | --- |
* | "No recent items. Start searching to see results." |
*
* @param {Navigation_No_Recent_ItemsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const navigation_no_recent_items = /** @type {((inputs?: Navigation_No_Recent_ItemsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Navigation_No_Recent_ItemsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine zuletzt verwendeten Elemente. Starten Sie die Suche, um Ergebnisse zu sehen.")
	return /** @type {LocalizedString} */ ("No recent items. Start searching to see results.")
});